import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaEllipsisV, FaMapMarkerAlt, FaRegDotCircle } from "react-icons/fa";
import cn from "classnames";

import { Page, DetailShipmentCard } from "ui/components";
import { formatDate } from "utilities/common";
import { Routing } from "services/action";

// import Additional from "./additional";

const CompleteScreen = ({ data }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const [routing, setRouting] = React.useState(null);

  const $getRouting = async () => {
    const req = await Dispatch(Routing.$manifest(data?.id));

    if (req?.message === "success") {
      setRouting(req?.data);
    }
  };

  React.useEffect(() => {
    if (!data) return;
    $getRouting();
  }, [data]);

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12">{content}</div>
      </div>
    );
  };

  const RouteLast = () => {
    return (
      <div className="position-relative">
        {routing?.actual?.legs?.map((d, i) => (
          <div key={i} className="position-relative">
            {i !== 0 && (
              <div className="position-absolute" style={{ top: "-35%" }}>
                <FaEllipsisV size="18" color="gray" />
              </div>
            )}
            <div className="row py-2">
              <div className="col-1">
                {d?.type === "pickup" && (
                  <FaRegDotCircle size="18" color="#2f83ba" />
                )}
                {d?.type === "drop_point" && (
                  <FaMapMarkerAlt size="18" color="#2fb344" />
                )}
              </div>
              <div className="col-11">
                <div className="list-item">
                  <div className="page-pretitle">
                    {d?.type?.replace("_", " ")}: {d?.location?.name}
                  </div>
                  <div className="title fw-bold">
                    {d?.location?.region?.district_name},{" "}
                    {d?.location?.region?.regency_name},{" "}
                    {d?.location?.region?.province_name}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Page title={`Detail Manifest`} backTo={() => History.goBack()}>
      <div className="py-2">
        <DetailShipmentCard title="Informasi">
          <ListHorizontal
            title="Kode Manifest"
            content={<div style={{ fontWeight: "bold" }}>{data?.code}</div>}
          />
          <ListHorizontal
            title="Tipe Manifest"
            content={
              <div
                className={
                  data?.type === "pickup"
                    ? "badge bg-dark-lt text-secodary ms-auto"
                    : data?.type === "console"
                    ? "badge bg-warning-lt text-warning ms-auto"
                    : data?.type === "last_mile"
                    ? "badge bg-primary-lt text-primary ms-auto"
                    : data?.type === "trucking"
                    ? "badge bg-cyan-lt text-cyan ms-auto"
                    : "badge bg-pink-lt text-pink ms-auto"
                }
              >
                {data?.type?.replace("console", "transit")?.replace("_", " ")}
              </div>
            }
          />
          <ListHorizontal
            title="Tanggal"
            content={formatDate(data?.shipping_date, "DD/MM/YYYY")}
          />
          <ListHorizontal
            title={
              data?.type === "pickup" ? "Mulai Penjemputan" : "Mulai Pengiriman"
            }
            content={
              <div>{formatDate(data?.started_at, "DD/MM/YYYY HH:mm")}</div>
            }
          />
          <ListHorizontal
            title={
              data?.type === "pickup"
                ? "Selesai Penjemputan"
                : "Selesai Pengiriman"
            }
            content={
              <div>{formatDate(data?.completed_at, "DD/MM/YYYY HH:mm")}</div>
            }
          />

          {/* <ListHorizontal
            title="KM Awal"
            content={currencyFormat(data?.start_odo)}
          />
          <ListHorizontal
            title="KM Akhir"
            content={currencyFormat(data?.end_odo)}
          />

          {!data?.legs && (
            <ListHorizontal
              title="Jarak Tempuh"
              content={currencyFormat(data?.mileage)}
            />
          )}

          <ListHorizontal
            title="Drop-Point"
            content={currencyFormat(data?.legs_count?.completed)}
          /> */}

          <ListHorizontal
            title="Status"
            content={
              <div className="badge bg-success-lt text-success ms-auto">
                {data?.status}
              </div>
            }
          />
        </DetailShipmentCard>

        {data?.legs && (
          <DetailShipmentCard
            title={`Rute Perjalanan (${routing?.actual?.distances?.text})`}
          >
            <RouteLast />
          </DetailShipmentCard>
        )}

        {/* <Additional id={data?.id} /> */}

        {(data?.type === "console" || data?.type === "pickup") &&
        data?.status === "process" ? (
          <div className="bg-warning-lt text-center p-2 border-warning border rounded">
            <div className="text-secondary fs-6">
              <div>Menunggu konfirmasi penerimaan dari Hub Tujuan</div>
            </div>
          </div>
        ) : null}
      </div>
    </Page>
  );
};

export default CompleteScreen;
